import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { categoryLinks } from "@/mocks/kakobuy-data";

export default function HeroSection() {
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
      setSelectedCategory("");
    }
  };

  return (
    <section className="relative min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20clean%20bright%20fashion%20flat%20lay%20from%20overhead%20angle%20featuring%20a%20pair%20of%20white%20designer%20sneakers%20a%20folded%20olive%20green%20hoodie%20a%20black%20baseball%20cap%20and%20a%20small%20leather%20crossbody%20bag%20arranged%20on%20a%20warm%20beige%20linen%20fabric%20background%20soft%20diffused%20afternoon%20light%20from%20an%20invisible%20window%20gentle%20shadows%20editorial%20minimalist%20product%20photography%20with%20plenty%20of%20breathing%20room&width=1600&height=900&seq=hero-v2-kakobuy-001&orientation=landscape"
          alt="Kakobuy Spreadsheet fashion products"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/85 to-background-50/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-0">
        <div className="max-w-xl">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 md:mb-5">
            Updated June 2026
          </span>

          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight text-balance mb-4 md:mb-5">
            Best Kakobuy Spreadsheet <span className="text-primary-500">2026</span>: Trusted Products, Sellers &amp; Buying Guides
          </h1>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 md:mb-7 max-w-lg">
            Explore verified <strong>Kakobuy Spreadsheet</strong> finds, trusted sellers, QC guides, and shopping resources updated weekly.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-5">
            <div className="relative flex-1">
              <select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="w-full appearance-none px-4 py-3 pr-10 rounded-lg bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all cursor-pointer"
              >
                <option value="">Browse by Category</option>
                {categoryLinks.map((cat) => (
                  <option key={cat.name} value={cat.url}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-down-s-line text-foreground-500 text-sm"></i>
              </div>
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Kakobuy Spreadsheet
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-foreground-800 text-foreground-800 text-sm font-semibold rounded-lg hover:bg-foreground-800 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line text-sm"></i>
            </a>
            <Link
              to="/guide"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 text-sm font-medium rounded-lg hover:bg-background-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Read the Guide
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-8 pt-6 border-t border-background-200/70">
            {[
              { icon: "ri-checkbox-circle-line", text: "Updated Weekly" },
              { icon: "ri-group-line", text: "Trusted Community" },
              { icon: "ri-shield-check-line", text: "Verified Sellers" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${item.icon} text-accent-500 text-sm`}></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}